import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CustomFacade,
  MyOrganizationFacade,
  ProjectsFacade,
  customDecode,
  customEncode,
  delayedFunctionCall,
  encrypt,
} from '@piqet-angular/data';
import { OrganizationPreferencesDataGridService } from '@piqet-angular/features';
import { ICellRendererParams } from 'ag-grid-community';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ProjectPackEOLDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-eol/project-scenario-eol-data-grid.service';
import { palletPackagingLevelId } from 'libs/shared/src/lib/constants';

@Component({
  selector: 'piqet-angular-inline-action-button',
  templateUrl: './inline-action-button.component.html',
  styleUrls: ['./inline-action-button.component.css'],
})
export class InlineActionButtonComponent implements OnDestroy {
  params: any;
  currentRoute: any;
  activeRoute: string | undefined;
  reviewName!: string;
  endPoint!: string;
  scenarioId: any;
  from: any;
  isShowEditProjectPackButton: boolean = false;
  isLastChild = true;
  activatedRouteProjectId: any;
  palletPackagingLevelId = palletPackagingLevelId;
  agInit(params: any): void {
    this.params = params;
    this.from = params.from;
    this.params.showInlineEdit = this.params.data.hasOwnProperty('isEdit') ? false : true;
    this.params.api.setFocusedCell(this.params.rowIndex, 'EnergyName');
    if (this.from == 'pallet-config-check') {
      this.isLastChild =
        this.params.data?.packagingLevelId == this.palletPackagingLevelId ? true : false;
    }
    if (this.params.data.productMixKeepEditing) {
      delayedFunctionCall(
        () => {
          this.params.api.startEditingCell({
            rowIndex: this.params.data.index,
            colKey: 'Name',
          });
        },
        0,
        this
      );
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.params.api.setFocusedCell(this.params.rowIndex, 'LandFill');
    return false;
  }

  constructor(
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private projectsService: ProjectsService,
    private projectsFacade: ProjectsFacade,
    private customFacade: CustomFacade,
    private projectPackEOLDataGridService: ProjectPackEOLDataGridService,
    private organizationPreferencesDataGridService: OrganizationPreferencesDataGridService,
    private myOrganizationFacade: MyOrganizationFacade
  ) {
    this.route.url.subscribe((url: any) => (this.currentRoute = url));
    this.activeRoute = this.route.snapshot.routeConfig?.path;
    if (location.href?.includes('scenario-configuration'))
      this.activatedRouteProjectId = Number(
        atob(decodeURIComponent(customDecode(location.href.split('/')[6])))
      );
  }

  editInlineGrid() {
    if (this.params.data?.packagingLevelId == this.palletPackagingLevelId) {
      return this.sharedService.openPalletViewModal(this.params.data);
    }
    this.enableDisableRow(false);
    switch (this.activeRoute) {
      case 'end-of-life':
        if (this.params.colDef.cellRendererParams.gridType == 'isConsumer') {
          this.projectsFacade.packageEOLConsumer$.subscribe((data: any) => {
            const selectedRow = data.filter((x: any) => x.index == this.params.node.rowIndex);
            localStorage.setItem('consumerEOL', JSON.stringify(selectedRow[0]));
          });
        } else {
          // RETAIL
          this.projectsFacade.packageEOLRetail$.subscribe((data: any) => {
            const selectedRow = data.filter((x: any) => x.index == this.params.node.rowIndex);
            localStorage.setItem('retailEOL', JSON.stringify(selectedRow[0]));
          });
        }
        var colId = this.params.columnApi.getDisplayedCenterColumns()[1].colId;
        this.params.data = { ...this.params.data, enableEditing: true };
        delayedFunctionCall(
          () => {
            this.params.api.startEditingCell({
              rowIndex: this.params.node.rowIndex,
              colKey: colId,
            });
            this.enableDisableRow(true);
          },
          0,
          this
        );
        this.params.api.setFocusedCell(this.params.node.rowIndex, colId);
        this.sharedService.disableAddRow('editingStarted');
        break;
      case 'organizationPreferences':
        if (this.from == 'organizationPreferencesDataMapping') {
          var colId = this.params.columnApi.getDisplayedCenterColumns()[0].colId;
          this.params.data = { ...this.params.data, enableEditing: true };
          delayedFunctionCall(
            () => {
              this.params.api.startEditingCell({
                rowIndex: this.params.node.rowIndex,
                colKey: colId,
              });
              this.enableDisableRow(true);
            },
            0,
            this
          );
          this.params.api.setFocusedCell(this.params.node.rowIndex, colId);
          this.sharedService.disableAddRow('editingStarted');
        } else {
          var colId = this.params.columnApi.getDisplayedCenterColumns()[4].colId;
          this.params.data = { ...this.params.data, enableEditing: true };
          delayedFunctionCall(
            () => {
              this.params.api.startEditingCell({
                rowIndex: this.params.node.rowIndex,
                colKey: colId,
              });
              this.enableDisableRow(true);
            },
            0,
            this
          );
          this.params.api.setFocusedCell(this.params.node.rowIndex, colId);
          this.sharedService.disableAddRow('editingStarted');
        }
        break;
      case 'report-generation':
        var colId = this.params.columnApi.getDisplayedCenterColumns()[1].colId;
        this.params.data = { ...this.params.data, enableEditing: true };
        delayedFunctionCall(
          () => {
            this.params.api.startEditingCell({
              rowIndex: this.params.node.rowIndex,
              colKey: 'Technology',
            });
            this.enableDisableRow(true);
          },
          0,
          this
        );
        this.params.api.setFocusedCell(this.params.node.rowIndex, colId);
        this.sharedService.disableAddRow('editingStarted');
        break;
      case 'scenario-configuration':
        var colId = this.params.columnApi.getDisplayedCenterColumns()[2].colId;
        this.params.data = { ...this.params.data, enableEditing: true };
        delayedFunctionCall(
          () => {
            this.params.api.startEditingCell({
              rowIndex: this.params.node.rowIndex,
              colKey: 'amount',
            });
            this.enableDisableRow(true);
          },
          0,
          this
        );
        this.params.api.setFocusedCell(this.params.node.rowIndex, colId);
        this.sharedService.disableAddRow('editingStarted');
        break;
      default:
        var colId = this.params.columnApi.getDisplayedCenterColumns()[0].colId;
        this.params.data = { ...this.params.data, enableEditing: true };
        this.activeRoute == 'interpretation' && this.params.editDataInlineReport(this.params);
        delayedFunctionCall(
          () => {
            this.params.api.startEditingCell({
              rowIndex: this.params.node.rowIndex,
              colKey: colId,
            });
            this.enableDisableRow(true);
          },
          0,
          this
        );
        this.params.api.setFocusedCell(this.params.node.rowIndex, colId);
        this.sharedService.disableAddRow('editingStarted');
        break;
    }
  }

  clearInlineEdit() {
    this.params.data = {
      ...this.params.data,
      resetData: true,
      enableEditing: false,
      isCheckUpdate: false,
      isCheckProductGroup: true,
    };
    this.params?.inlineEditData(this.params);
    this.sharedService.disableAddRow('editingStopped');
    this.params.api.stopEditing();
    this.params.api.clearFocusedCell();
    this.enableDisableRow(false);
  }

  copyData() {
    let error;
    switch (this.from) {
      case 'customMaterialIngredient':
        this.customFacade.customMaterialIngredirentError$.subscribe((data: any) => {
          error = data;
        });
        break;
      case 'customfilling':
        this.customFacade.customFillingError$.subscribe((data: any) => {
          error = data;
        });
        break;
      case 'customStorage':
        this.customFacade.customStorageError$.subscribe((data: any) => {
          error = data;
        });
        break;
      case 'customConversion':
        this.customFacade.GetCustomConversionProcessError$.subscribe((data: any) => {
          error = data;
        });
        break;
      case 'customReuse':
        this.customFacade.customReuseError$.subscribe((data: any) => {
          error = data;
        });
        break;
      default:
        break;
    }
    if (error) {
      return;
    }

    this.params?.copyData(this.params.node.data, this.activeRoute);
    this.params?.copyDataEditRendarar(this.params.node.data, this.activeRoute);
    this.sharedService.disableAddRow('editingStopped');
    this.enableDisableRow(false);
  }

  saveInlineGridProject() {
    this.isShowEditProjectPackButton = false;
    this.params.data = { ...this.params.data, resetData: false };
    this.params?.saveDataInline(this.params.data);
  }

  clearInlineEditProject() {
    this.isShowEditProjectPackButton = false;
    this.params.data = { ...this.params.data, resetData: false, enableEditing: false };
    // need in future
    // this.params?.editDataInline(this.params.data, this.activeRoute);
    this.params?.clearInputField('');
    this.enableDisableRow(false);
  }

  editInlineForProject() {
    if (this.params.type == 'projectMaterial') [];
    this.params.data = { ...this.params.data, resetData: false, enableEditing: true };
    this.params?.editDataInline(this.params.data, this.activeRoute);
  }

  deleteInlineGrid() {
    this.params.data = { ...this.params.node.data, resetData: false, enableEditing: false };
    this.params?.deleteInlineGrid(this.params.data, this.activeRoute);
    this.sharedService.disableAddRow('editingStopped');
    this.enableDisableRow(false);
  }

  saveInlineGrid() {
    switch (this.activeRoute) {
      case 'end-of-life':
        const isPackageDataInvalid = this.projectPackEOLDataGridService.savePackageEOLData(
          this.params.columnApi.columnModel.columnDefs[
            this.params.columnApi.columnModel.columnDefs.length - 1
          ].cellRendererParams.gridType
        );
        if (isPackageDataInvalid) {
          this.params.data = {
            ...this.params.data,
            resetData: false,
            enableEditing: true,
            isInvalid: true,
          };
          this.params?.inlineEditData(this.params);
        } else {
          this.params.data = {
            ...this.params.data,
            resetData: false,
            enableEditing: false,
            isInvalid: false,
          };
          this.params?.inlineEditData(this.params);
          this.sharedService.disableAddRow('editingStopped');
          this.params.api.stopEditing();
        }
        break;
      case 'organizationPreferences':
        if (this.from == 'organizationPreferencesDataMapping') {
          this.projectsFacade.checkUpdateActionForOrganizationMapping(true);
          this.params.data = {
            ...this.params.data,
            resetData: false,
            enableEditing: false,
            isCheckUpdate: true,
          };
          this.params?.inlineEditData(this.params);
          this.sharedService.disableAddRow('editingStopped');
          this.params.api.stopEditing();
          this.projectsFacade.checkUpdateActionForOrganizationMapping(false);
        } else {
          this.params.data = { ...this.params.data, resetData: false, enableEditing: false };
          this.params?.inlineEditData(this.params);
          this.sharedService.disableAddRow('editingStopped');
          this.params.api.stopEditing();
        }
        break;
      case 'product':
        this.projectsFacade.checkUpdateActionForProdLoss(true);
        this.params.data = {
          ...this.params.data,
          resetData: false,
          enableEditing: false,
          isCheckUpdate: true,
        };
        this.params?.inlineEditData(this.params);
        this.sharedService.disableAddRow('editingStopped');
        this.params.api.stopEditing();
        this.projectsFacade.checkUpdateActionForProdLoss(false);
        break;
      case 'organization-main-mapping':
        this.projectsFacade.checkUpdateActionForOrganizationMapping(true);
        this.params.data = {
          ...this.params.data,
          resetData: false,
          enableEditing: false,
          isCheckUpdate: true,
        };
        this.params?.inlineEditData(this.params);
        this.sharedService.disableAddRow('editingStopped');
        this.params.api.stopEditing();
        this.projectsFacade.checkUpdateActionForOrganizationMapping(false);
        break;
      case 'interpretation':
        this.projectsFacade.checkUpdateActionForPInterpretation(true);
        this.params.data = {
          ...this.params.data,
          resetData: false,
          enableEditing: false,
          isCheckUpdate: true,
        };
        this.params?.inlineEditData(this.params);
        this.sharedService.disableAddRow('editingStopped');
        this.params.api.stopEditing();
        this.projectsFacade.checkUpdateActionForPInterpretation(false);
        break;
      default:
        location.href.includes('upload-sku')
          ? this.myOrganizationFacade.checkUpdateActionForSKU(true)
          : location.href.includes('end-of-life')
          ? this.projectsFacade.checkUpdateActionForReuse(true)
          : location.href.includes('product-ingredient') ||
            location.href.includes('product-manufacture')
          ? this.projectsFacade.checkUpdateActionForIngredient(true)
          : this.customFacade.checkUpdateActionFire(true);
        this.params.data = {
          ...this.params.data,
          resetData: false,
          enableEditing: false,
          isInvalid: false,
          isCheckUpdate: true,
        };
        this.params?.inlineEditData(this.params);
        this.sharedService.disableAddRow('editingStopped');
        this.params.api.stopEditing();
        location.href.includes('upload-sku')
          ? this.myOrganizationFacade.checkUpdateActionForSKU(false)
          : location.href.includes('end-of-life')
          ? this.projectsFacade.checkUpdateActionForReuse(false)
          : location.href.includes('product-ingredient') ||
            location.href.includes('product-manufacture')
          ? this.projectsFacade.checkUpdateActionForIngredient(false)
          : this.customFacade.checkUpdateActionFire(false);
        break;
    }
    this.enableDisableRow(false);
  }

  isEditMode() {
    const cellDefs = this.params.api.getEditingCells();
    if (this.from == 'pallet-config-check') {
      return false;
    } else if (cellDefs.length) {
      return cellDefs[0].rowIndex == this.params.node.rowIndex ? true : false;
    } else {
      return false;
    }
  }

  enableDisableRow(value: boolean) {
    const allCellElements = document.querySelectorAll('.ag-cell-not-inline-editing');
    allCellElements.forEach((element: any) => {
      element.style.pointerEvents = value ? 'none' : '';
    });
  }

  ngOnDestroy() {
    this.enableDisableRow(false);
  }
}
